jQuery(function($) {
  $(".meter > span").each(function() {
    $(this)
      .data("origWidth", $(this).width()/$(this).parent().width()*100)
      .width(0)
      .animate({
        width: $(this).data("origWidth")+'%'
      }, 1200);
  });
});
